import "./callCenter.scss";
import { NavLink } from "react-router-dom";

export default function CallCenter() {
  return (
    <div className="callCenter">
      <div className="callCenter__title">
        <h2>
          Hello! Here we are going to set up your{" "}
          <span>call center account. </span>
        </h2>
        <p>You just need to answer few questions about your business. </p>
      </div>
      <div className="callCenter__button">
        <NavLink to="/chat">Start now</NavLink>
      </div>
    </div>
  );
}
